import React from "react";
import { Box, FormControl, InputLabel, MenuItem, Select, Typography } from "@mui/material";
import { ParticipantToProgrammeType } from "../../models/modelTypes";
import { AllSessionsGrid } from "../session/components/AllSessionsGrid";
import { getProgrammeSummaryLabel, countCompletedSessions } from "../../utils/participantOverview";

type ParticipantOverviewTabProps = {
    programmes: ParticipantToProgrammeType[];
    programmeIdFilter?: number;
    onProgrammeFilterChange: (programmeId?: number) => void;
};

export const ParticipantOverviewTab: React.FC<ParticipantOverviewTabProps> = ({
    programmes,
    programmeIdFilter,
    onProgrammeFilterChange,
}) => {
    const filteredProgrammes =
        programmeIdFilter === undefined
            ? programmes
            : programmes.filter((ptp) => ptp.programmeId === programmeIdFilter);

    return (
        <Box>
            {programmes.length > 1 && (
                <Box mb={3} maxWidth={320}>
                    <FormControl fullWidth size="small">
                        <InputLabel id="participant-programme-filter-label">Programme</InputLabel>
                        <Select
                            labelId="participant-programme-filter-label"
                            label="Programme"
                            value={programmeIdFilter ?? "all"}
                            onChange={(event) => {
                                const value = event.target.value;
                                onProgrammeFilterChange(value === "all" ? undefined : Number(value));
                            }}
                        >
                            <MenuItem value="all">All programmes</MenuItem>
                            {programmes.map((ptp) => (
                                <MenuItem key={ptp.id} value={ptp.programmeId}>
                                    {ptp.Programme.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>
            )}

            {filteredProgrammes.length === 0 ? (
                <Typography color="textSecondary">No programme data available for this participant.</Typography>
            ) : (
                filteredProgrammes.map((ptp) => {
                    const sessions = ptp.Programme.Sessions ?? [];
                    const completedCount = countCompletedSessions(sessions);

                    return (
                        <Box key={ptp.id} mb={4}>
                            <Typography variant="h5" gutterBottom>
                                {ptp.Programme.name}
                            </Typography>
                            <Typography variant="body2" color="textSecondary" gutterBottom>
                                {getProgrammeSummaryLabel(ptp)}
                            </Typography>
                            <Typography variant="body2" color="textSecondary" gutterBottom>
                                Session {completedCount} of {sessions.length}
                            </Typography>
                            {sessions.length > 0 ? (
                                <AllSessionsGrid sessions={sessions} />
                            ) : (
                                <Typography color="textSecondary">No sessions scheduled yet.</Typography>
                            )}
                        </Box>
                    );
                })
            )}
        </Box>
    );
};
